export default __webpack_public_path__ + "static/media/laudo3.f69eed98.jpg";